import React, { useMemo } from "react";
import { StyleSheet } from "react-native";
import NtTouchableEffect from "./NtTouchableEffect";
import NtMaterialIcon from "./NtMaterialIcon";
import NtActivityIndicator from "./NtActivityIndicator";
import { useTheme } from "../context/ThemeContext";

function NtListActionButton({
  containerStyle,
  onPress,
  icon = "pencil",
  color,
  loading = false,
}) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const fg = color || theme.textDim;

  return (
    <NtTouchableEffect style={[styles.container, containerStyle]} onPress={onPress}>
      {loading ? (
        <NtActivityIndicator color={fg} size="small" />
      ) : (
        <NtMaterialIcon name={icon} color={fg} size={14} />
      )}
    </NtTouchableEffect>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {
      width: 28,
      height: 28,
      borderRadius: t.radius,
      alignItems: "center",
      justifyContent: "center",
      borderColor: t.border,
      borderWidth: 1,
      backgroundColor: t.surface2,
    },
  });

export default NtListActionButton;
